import type { Actor, Step } from '../../drilleditor/types';
import { useI18n } from '../../i18n';
import ExercisePlayback from './ExercisePlayback';

type Props = {
  id: string;
  title: string;
  actors: Actor[];
  timeline: Step[];
  tags: string[];
  categories: string[];
  notes: string[];
};

/** Shared presentation; authorization and loading stay with each route. */
export default function ExerciseContent({ tags, categories, notes, ...playback }: Props) {
  const { t } = useI18n();
  const labels = [...categories, ...tags].filter(Boolean);
  const hasDetails = labels.length > 0 || notes.length > 0;
  return (
    <div className={hasDetails ? 'grid lg:grid-cols-[minmax(0,1.3fr)_minmax(260px,1fr)] lg:divide-x lg:divide-gray-200' : ''}>
      <section className="min-w-0 p-4 sm:p-6">
        <ExercisePlayback {...playback} />
      </section>
      {hasDetails && <aside className="min-w-0 space-y-5 border-t border-gray-200 p-4 sm:p-6 lg:border-t-0">
        {notes.length > 0 && <section>
          <h2 className="text-sm font-semibold text-gray-950">{t('training_exercises_detail_notes')}</h2>
          <ul className="mt-3 space-y-2 text-sm leading-6 text-gray-700">{notes.map((note, index) => <li className="whitespace-pre-wrap break-words" key={index}>{note}</li>)}</ul>
        </section>}
        {labels.length > 0 && <section>
          <h2 className="text-sm font-semibold text-gray-950">{t('training_exercises_detail_properties')}</h2>
          <p className="mt-2 break-words text-sm text-gray-600">{labels.join(' · ')}</p>
        </section>}
      </aside>}
    </div>
  );
}
